module.exports = __webpack_public_path__ + "img/36.2c8cf864.png";